// lib
import { connect } from "react-redux";
import { withRouter } from "react-router";
// src
import Component from "components/plannings/routes/DeepLink";
import { exclusiveLightEnable } from "actions/presets";
import { manageAddToLocals } from "actions/presets/thunks";
import { computeDisplay, fetchEnableds } from "actions/events/thunks";

const mapDispatchToProps = {
  manageAddToLocals,
  computeDisplay,
  exclusiveLightEnable,
  fetchEnableds,
};

export default connect(null, mapDispatchToProps)(withRouter(Component));
